import { lazy, Suspense } from 'react';
import { useSession } from '../lib/session';

/**
 * Agentation visual-feedback toolbar (dev tool), gated + lazy-loaded so it is
 * NEVER shipped to members. It mounts only on localhost (import.meta.env.DEV)
 * or, on production, for a signed-in `developer` - and the chunk is lazy, so
 * everyone else never even downloads it. Click an element on the page, jot a
 * note, and copy the structured markdown to hand a coding agent the exact
 * selector + context. Remove the <DevAnnotation /> mount in App.tsx to retire.
 */
const Agentation = lazy(() => import('agentation').then((m) => ({ default: m.Agentation })));

export function DevAnnotation() {
  const { profile } = useSession();
  const enabled = import.meta.env.DEV || profile?.role === 'developer';
  if (!enabled) return null;
  return (
    <Suspense fallback={null}>
      <Agentation />
    </Suspense>
  );
}
